/** One labelled row in a detail drawer's metadata sidebar. */
export function MetaRow({
	icon,
	label,
	children,
}: {
	icon: React.ReactNode;
	label: string;
	children: React.ReactNode;
}) {
	return (
		<div className="flex items-start gap-3 py-2.5">
			<div className="flex w-24 shrink-0 items-center gap-1.5 pt-1.5 text-xs text-muted">
				{icon}
				{label}
			</div>
			<div className="min-w-0 flex-1 text-sm text-foreground">
				{children}
			</div>
		</div>
	);
}
